import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { PPC_STARGATE_PREFIX } from '@atlassian/temp-client-utils';
// Custom hook to fetch SSR component's HTML
export const useSSRComponent = (route: string) => {
  const [ssrHtml, setSsrHtml] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const asyncFetch = async () => {
      try {
        const response = await fetch(`${PPC_STARGATE_PREFIX}/ux/ssr/${route}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } else {
          const data = await response.text();
          const cleanData = DOMPurify.sanitize(data);
          setSsrHtml(cleanData);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        setError(true);
      }
    };
    asyncFetch();
  }, [route]);

  return { ssrHtml, error };
};
